
var id = "gailan";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 792 792\" id=\"gailan\">\n<style type=\"text/css\">\n\t#gailan .st0{clip-path:url(#gailan_SVGID_2_);}\n</style>\n<g>\n\t<g>\n\t\t<defs>\n\t\t\t<rect id=\"gailan_SVGID_1_\" x=\"12.95\" y=\"0.08\" width=\"766.06\" height=\"791.88\" />\n\t\t</defs>\n\t\t<clipPath id=\"gailan_SVGID_2_\">\n\t\t\t<use xlink:href=\"#gailan_SVGID_1_\" style=\"overflow:visible;\" />\n\t\t</clipPath>\n\t\t<path class=\"st0\" d=\"M741.3,564.18c12.57-6.18,27.77-1.06,34.05,11.46c6.27,12.52,1.27,27.77-11.2,34.14L407.1,788.3\n\t\t\tc-7.19,3.6-15.66,3.6-22.85,0L27.21,609.78c-8.22-4.04-13.64-12.17-14.21-21.31c-0.56-9.14,3.82-17.89,11.48-22.91\n\t\t\tc7.66-5.02,17.42-5.55,25.58-1.38l345.62,172.76L741.3,564.18z M775.53,371.53c5.53,11.02,2.37,24.43-7.5,31.83l-3.88,2.4\n\t\t\tL407.1,584.27c-5.69,2.85-12.24,3.47-18.36,1.74l-4.49-1.74L27.21,405.75c-11.79-5.91-17.13-19.84-12.31-32.12\n\t\t\tc4.82-12.28,18.21-18.85,30.88-15.16l4.28,1.68l345.62,172.76L741.3,360.1c12.59-6.31,27.91-1.22,34.23,11.37V371.53z M407.1,3.1\n\t\t\tl357.05,178.53c8.63,4.32,14.08,13.15,14.08,22.8c0,9.65-5.45,18.47-14.08,22.8L407.1,405.75c-7.19,3.6-15.66,3.6-22.85,0\n\t\t\tL27.21,227.22c-8.63-4.32-14.08-13.15-14.08-22.8c0-9.65,5.45-18.48,14.08-22.8L384.25,3.1C391.44-0.5,399.92-0.5,407.1,3.1\n\t\t\tL407.1,3.1z M395.68,54.41L95.66,204.43l300.02,150.01L695.7,204.43L395.68,54.41z M395.68,54.41\" />\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
